<template>
    <div class="pb-4">
        <ConfirmDialog></ConfirmDialog>
        <div class="flex align-items-center justify-content-between mb-3">
            <div class="text-900 font-medium text-xl">{{ comments.length }} Comments</div>
        </div>
        <ul class="list-none p-0 m-0">
            <li v-for="comment in comments" :key="comment.id" class="py-3 border-bottom-1 surface-border flex md:align-items-start md:justify-content-between flex-column md:flex-row">
                <div class="flex align-items-start mr-0 lg:mr-5">
                    <img class="mr-3 w-3rem h-3rem" :src="genericAvatar"/>
                    <div>
                        <span class="text-900 font-medium block mb-2">{{ comment.user.name }}</span>
                        <div class="text-700 mb-2">{{ comment.comment_message }}</div>
                        <a class="text-primary cursor-pointer">
                                <span v-if="comment.user.id === user?.id">
                                    <Button
                                        class="p-button-rounded p-button-danger p-button-text" icon="pi pi-trash"
                                        @click.prevent="deleteComment(comment.id)">
                                    </Button>
                                </span>
                        </a>
                    </div>
                </div>
                <span class="block text-500 font-medium ml-7 md:ml-5 mt-2 md:mt-0">{{ date(comment.created_at) }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import genericAvatar from '/resources/images/blocks/avatars/circle/generic_avatar.png';
import moment from "moment-timezone";

export default {
    props    : {
        comments : Object,
    },
    data() {
        return {
            genericAvatar
        }
    },
    methods  : {
        date(date) {
            return moment(date).format("D MMM YYYY, H:mm");
        },
        deleteComment(comment) {
            this.$confirm.require({
                message     : 'Are you sure you want to delete this comment?',
                header      : 'Confirmation',
                acceptClass : 'p-button-secondary',
                icon        : 'pi pi-exclamation-triangle',
                accept      : () => {
                    this.$inertia.delete(route("newsportal.comments.destroy", comment), {
                        preserveScroll : true,
                    });
                },
                reject      : () => {
                }
            });
        },
    },
    computed : {
        user() {
            return this.$page.props.auth.user;
        },
    },
};
</script>
